import { Pipe, PipeTransform } from '@angular/core';

import { CurrencyService } from '../../services/currency.service';

@Pipe({
    name: 'localCurrencyFormatter'
})
export class LocalCurrencyFormatterPipe implements PipeTransform {
    constructor(private currencyService: CurrencyService) { }
    transform(value: number | string, minimumFractionDigits?: any): any {
        if (value) {
            return this.currencyService.formatNumberCurrency(value.toString(), minimumFractionDigits);
        } else {
            return this.currencyService.formatNumberCurrency(value, minimumFractionDigits);
        }
    }
}
